import { DashboardBilling } from '@/pages/DashboardBilling'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$orgId/dashboard/billing')({
  component: DashboardBilling,
  meta: () => [{ title: 'Billing' }],
})
